import { render } from "./ProductBoxSegmentHeader.vue?vue&type=template&id=6a896e19&ts=true"
import script from "./ProductBoxSegmentHeader.vue?vue&type=script&lang=ts"
export * from "./ProductBoxSegmentHeader.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__